import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trim'
})
export class TrimPipe {
  transform(value: string, args: String[]): string {
    return value.replace(/ /g, "").replace("/", "");
  }
}
